<template>
  <div>
    <div class="h-full">
      <div class="rounded bg-white grid grid-cols-12 " :style="`height:` +  mainHeight + `px; !important`">
        <div class=" mx-2 shadow-md relative" :class="isFilterOpen ? 'box col-span-9' : 'box col-span-12'">
          <div class="bg-white cust_card p-2 heading-3 text-red-500 justify-between flex">
            <p>Revenue by Channel</p>
            <div class="top-0 absolute" :class="isFilterOpen ? '-right-4' : 'transition-all delay-75 -right-2'" >
              <button id="toggle" class="bg-gray-600 hover:bg-gray-700 transition delay-75 w-11 h-11 rounded-l-full " @click="openCloseFilter()">
                <span v-if="isFilterOpen"><i class="fas fa-caret-right h-6 w-6 text-white mt-1"></i></span>
                <p v-if="!isFilterOpen"><i class="fas fa-caret-left h-6 w-6 text-white mt-1"></i></p>
              </button>
            </div>
          </div>
          <div style="overflow-y: auto; white-space: nowrap;overflow-x: hidden;" class="table_containder" v-if="listingObjectArr.length > 0 && firstLoading">
            <div :style="`max-height:` +  cardHight + `px; !important`" class="pt-2">
              <div id="chart" class="graphic-containerA">
                <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
              </div>
            </div>
          </div>
          <div class="layout m-2" v-if="listingObjectArr.length === 0 && firstLoading">
            <div class="flex p-3 text-sm text-primary2 bg-white border-blue-100 border-2 rounded-lg  items-center" role="alert">
              <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
              <span class="sr-only">Info</span>
              <div>
                <p class=" font-medium heading-4">No record found.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="box col-span-3 overflow-y-auto mx-2 shadow-md transition-transform delay-300 ease-in-out transition-2" id="mainDiv" v-if="isFilterOpen">
          <div class="bg-white">
            <div class=" bg-primary2 p-2 items-center justify-between flex h-11 sticky top-0">
              <div class="heading-4 text-white font-bold">Filter</div>
              <span class="centerLine">
                <div class=" text-white cursor-pointer hover:underline mr-2" @click="resetAll()">
                  <button style="letter-spacing: 1px;" class="border border-gray1 px-3 py-1 cust_card heading-7">Reset</button>
                </div>
                <div class=" text-white cursor-pointer hover:underline" @click="applyFilter()">
                  <button style="letter-spacing: 1px;" class="border border-gray1 px-3 py-1 cust_card heading-7">Apply</button>
                </div>
              </span>
            </div> 
            <div class="pt-1">
              <div v-if="filterObject.startDate !== '' || filterObject.endDate !== ''">
                <p class="text-text1 heading-6 font-bold pl-2">
                  <span class="text-text2 heading-6 font-bold">{{filterObject.startDate | DMMYYYYddd}}</span> 
                  To
                  <span class="text-text2 heading-6 font-bold">{{filterObject.endDate | DMMYYYYddd}}</span>
                </p>
              </div>
              <div class="pt-1 pl-1">
                <button style="letter-spacing: 1px"
                v-for="(data, index) in buttonFiltersArray" :key="index"
                  @click="getDateTimeForFilterHandler(index, true)"
                  :class="data.selected ? 'text-white bg-primary2' : 'text-primary2 bg-white hover:bg-blue-50'"
                  class="m-1 px-1 py-0.5 heading-7 rounded-md border border-primary2"
                  >{{data.title}}</button
                >
              </div>
            </div>
            <div class="divider m-1"></div>
            <div class="p-2 my-1 cust_card group" >
              <div class="centerLine justify-between ">
                <div class="centerLine">
                  <span class=" text-text2 heading-6 font-bold">Brand</span>
                  <div class="loader2 ease-linear ml-2" v-if="isOrderReqLoading"></div>
                </div>
                <div class="centerLine  pt-2 pb-1">
                  <div class="pr-2 cursor-pointer" @click="brandLoader = !brandLoader">
                    <span v-if="!brandLoader"><i class="fas fa-magnifying-glass h-4 w-4 text-gray4"></i></span>
                    <p v-if="brandLoader"><i class="fas fa-times h-4 w-4 text-gray4"></i></p>
                  </div>
                  <div class="pr-2 ">
                    <button  @click="resetOrderReq()" style="letter-spacing: 0.5px;" class="border border-gray-400 rounded-md px-2 heading-7 cursor-pointer">Clear</button>
                  </div>
                  <span @click="selectedAll('itemNameList')" class="centerLine cursor-pointer" v-if="brandList.length > 0">
                    <input type="checkbox" class="w-4 h-4 cursor-pointer" v-model="brandSelAll" >
                    <div class="text-text1 pl-1 heading-6 cursor-pointer">
                      {{!brandSelAll ? 'All' : 'Null'}}
                    </div>
                  </span>
                </div>
              </div>
              <div style="display:flex" class=" text-text2 bg-white border border-gray-500 rounded-md px-2 py-1 items-center h-7" v-if="brandLoader">
                <span class="mr-2 cursor-pointer"><i class="fas fa-magnifying-glass h-4 w-4 text-gray4"></i></span>
                <input class="focus:outline-none w-96 text-text2" autocomplete="off" type="text" name="" placeholder="Item Name Search" id="custSearchInput2"
                  v-model="brandSearch"
                >
                <span v-if="brandSearch.length > 0" class="cursor-pointer"  @click="clearOrderReq()">
                  <i class="fas fa-times h-4 w-4 text-gray4"></i>
                </span>
              </div>
              <div class="overflow-auto" style="max-height: 280px !important;" v-if="brandList.length > 0">
                <div v-for="(data, index) in brandList" :key="index">
                  <div class="centerLine" @click="selectData(data, index, 'itemNameList')">
                    <input type="checkbox" class="h-4 w-4 cursor-pointer" v-model="data.isSelected" >
                    <p class=" text-text1 pl-1 heading-6 cursor-pointer overFlowParaA w-96">{{data.displayName}}</p>
                  </div>
                </div>
              </div>
              <div class="layout" v-if="brandList.length === 0 && isRefresh">
                <div class="flex p-1 text-sm text-text1 bg-gray2 rounded items-center" role="alert">
                  <div>
                    <p class=" font-medium heading-5">No record found.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white container" v-if="showCustomDatepicker" >
      <div class="popup_overlay">
        <CustomDateSelector :appliedFilters="filterObject" @closeSelectedDialog="customDateListener" v-if="showCustomDatepicker"/>
      </div>
    </div>
</div>
</template>
<script>
import deboucneMixin from '@/mixins/debounce.js'
import moment from 'moment'
import API from '@/api/App.js'
import CustomDateSelector from '@/View/components/customDateSelection'
import {getDayAccordingToLimits} from '@/utils/convertDateAndTime.js'
// import Pagination from '@/View/components/pagination.vue'
export default {
  components: {
    CustomDateSelector,
  },
  mixins: [deboucneMixin],
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
          height: 'auto',
          stacked: true,
        },
        plotOptions: {
          bar: {
            columnWidth: '',
            horizontal: false,
            dataLabels: {
              total: {
                enabled: false,
                offsetX: 0,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
          group: {
            style: {
              fontSize: '10px',
              fontWeight: 700
            },
            groups: [
            ]
          },
          labels: {
            formatter: function (val) {
              return val + ""
            }
          }
        },
        yaxis: [
          {
            labels: {
              formatter: function(value) {
                var val = Math.abs(value)
                if (val >= 1000) {
                  val = (val / 1000).toFixed(0) + ' K'
                }
                return val
              }
            }
          }
        ],
        tooltip: {
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            console.log('series', series)
            console.log('seriesIndex', seriesIndex)
            console.log('dataPointIndex', dataPointIndex)
            console.log('w', w)
            return '<ul style="padding:4px;">' +
            '<li style="display:flex"><b>Post Date</b>: <p style="width:200px !important;overflow-wrap: anywhere;white-space: pre-wrap;">' + w.config.xaxis.categories[dataPointIndex] + '</p></li>' +
            '<li><b>' + w.config.series[seriesIndex].name + '</b>: $' + w.config.series[seriesIndex].data[dataPointIndex].toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</li>' +
            '</ul>';
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      },
      series: [],
      brandLoader: false,
      tempBrandList: [],
      brandSelAll: false,
      isFilterOpen: true,
      isRefresh: true,
      brandSearch: '',
      searchLoader: false,
      listingObjectArr: [],
      brandList: [
        { displayName: 'Sage', isSelected: false},
        { displayName: 'Extreme dog door', isSelected: false},
        { displayName: 'Extreme dog fence ', isSelected: false},
        { displayName: 'FlexPetz', isSelected: false},
        { displayName: 'Perimeter Technologies', isSelected: false},
        { displayName: 'eBay', isSelected: false},
        { displayName: 'Walmart ', isSelected: false}
      ],
      mainList: [
        { displayName: 'Sage', isSelected: false},
        { displayName: 'Extreme dog door', isSelected: false},
        { displayName: 'Extreme dog fence ', isSelected: false},
        { displayName: 'FlexPetz', isSelected: false},
        { displayName: 'Perimeter Technologies', isSelected: false},
        { displayName: 'eBay', isSelected: false},
        { displayName: 'Walmart ', isSelected: false}
      ],
      requiredDataListing: [],
      getDebounceList: () => {},
      isOrderReqLoading: false,
      buttonFiltersArray: [
        {
          title: 'Today',
          selected: false,
          value: 'today'
        },
        {
          title: 'Yesterday',
          selected: false,
          value: 'yesterday'
        },
        {
          title: 'Last Week',
          selected: false,
          value: 'lastWeek'
        },
        {
          title: 'Last 7 Days',
          selected: false,
          value: 'thisWeek'
        },
        {
          title: 'Last Month',
          selected: false,
          value: 'lastMonth'
        },
        {
          title: 'Last 30 Days',
          selected: true,
          value: 'last30Days'
        },
        {
          title: 'Last 60 Days',
          selected: false,
          value: 'last60Days'
        },
        {
          title: 'Last 90 Days',
          selected: false,
          value: 'last90Days'
        },
        {
          title: 'Last 120 Days',
          selected: false,
          value: 'last120Days'
        },
        {
          title: 'Custom',
          selected: false,
          value: 'custom'
        }
      ],
      selectedValue: 'last30Days',
      filterObject: {
        itemNameList: [],
        startDate: '',
        endDate: '',
        minDate: '',
        maxDate: '',
      },
      cardHight: 0,
      mainHeight: 0,
      defaultStartDate: '',
      defaultEndDate: '',
      showCustomDatepicker: false,
      firstLoading: false,
    }
  },
  created() {
  },
  beforeMount () {
  },
  mounted () {
    this.getDebounceList = this.debounce(function () {
      this.searchList()
    }, 500)
    this.cardHight = window.innerHeight - 171
    this.mainHeight = window.innerHeight - 90
    console.log('this.cardHight', this.cardHight, this.mainHeight)
    this.defaultEndDate = new Date()
    let currentDate = new Date()
    this.defaultStartDate = new Date(currentDate.setDate(currentDate.getDate() - 29))
    this.filterObject.startDate = this.defaultStartDate
    this.filterObject.endDate = this.defaultEndDate
    this.apiCaller()
  },
  watch: {
    brandSearch: {
      handler() {
        this.getDebounceList()
      }
    },
    tempBrandList: {
      handler () {
        console.log('tempBrandList', this.tempBrandList)
        this.filterObject.itemNameList = []
        this.tempBrandList.forEach(a => {
          if (a.displayName !== '') {
            this.filterObject.itemNameList.push(a.displayName)
          }
        })
      },
      deep: true
    },
    filterObject: {
      handler () {
        console.log('filterObject', this.filterObject)
      },
      deep: true
    },
  },
  methods: {
    selectedAll () {
      this.tempBrandList = []
      if (this.brandSelAll === true) {
        this.brandSelAll = false
      } else {
        this.brandSelAll = true
      }
      if (this.brandSearch === '') {
        if (this.brandSelAll) {
          console.log('stage 1')
          this.tempBrandList = []
          for (let index = 0; index < this.brandList.length; index++) {
            this.brandList[index].isSelected = true
          }
        } else if (!this.brandSelAll) {
          this.tempBrandList = []
          for (let index = 0; index < this.brandList.length; index++) {
            this.brandList[index].isSelected = false
            this.tempBrandList = []
          }
        }
      } else if (this.brandSearch !== '') {
        if (this.brandSelAll) {
          console.log('stage 3')
          for (let index = 0; index < this.brandList.length; index++) {
            if (this.brandList[index].isSelected === false) {
              this.brandList[index].isSelected = true
              this.tempBrandList.push(this.brandList[index])
            }
          }
        } else if (!this.brandSelAll) {
          console.log('stage 4')
          this.tempBrandList = []
          for (let J = 0; J < this.brandList.length; J++) {
            this.brandList[J].isSelected = false
          }
        }
      }
    },
    resetAll () {
      this.filterObject.startDate = this.defaultStartDate
      this.filterObject.endDate = this.defaultEndDate
      this.resetOrderReq()
      for (let i = 0; i < this.buttonFiltersArray.length; i++) {
        if (this.buttonFiltersArray[i].value === 'last30Days') {
          this.selectedValue = 'last30Days'
          this.buttonFiltersArray[i].selected = true
        } else {
          this.buttonFiltersArray[i].selected = false
        }
      }
    },
    resetOrderReq () {
      this.brandSearch = ''
      this.brandSelAll = false
      this.filterObject.itemNameList = []
      this.tempBrandList = []
      for (let index = 0; index < this.brandList.length; index++) {
        this.brandList[index].isSelected = false
      }
    },
    clearOrderReq () {
      this.brandSearch = ''
      // this.searchList(false)
    },
    openCloseFilter () {
      this.isFilterOpen = !this.isFilterOpen
      console.log('openCloseFilter')
    },
    customDateListener (data) {
      console.log('datadatadatadatadatadata', data)
      this.showCustomDatepicker = false
      if (data !== null) {
        this.filterObject.startDate = data.startDate
        this.filterObject.endDate = data.endDate
        // this.getListing()
      }
    },
    searchList () {
      if (this.brandSearch.length === 0) {
          this.brandList = this.mainList
        } else {
          let filter = this.brandSearch.toLowerCase();
          this.brandList = []
          for (let index = 0; index < this.mainList.length; index++) {
            if (this.brandSearch.toLowerCase().indexOf(filter) > -1 === this.mainList[index].displayName.toLowerCase().indexOf(filter) > -1) {
                this.brandList.push(this.mainList[index])
            }
          }
        }
    },
    selectData (data, index) {
      if (!this.brandSelAll) {
        data.isSelected = !data.isSelected
        if (data.isSelected) {
          this.tempBrandList.push(data)
        } else {
          const findex = this.tempBrandList.findIndex(x => x.displayName === data.displayName)
          this.brandList[index].isSelected = false
          this.tempBrandList.splice(findex, 1)
        }
      } else {
        data.isSelected = !data.isSelected
        this.tempBrandList = []
        for (let I = 0; I < this.brandList.length; I++) {
          if (this.brandList[I].isSelected === true) {
            this.tempBrandList.push(this.brandList[I])
          }
          this.brandSelAll = false   
        }
      }
    },
    getDateTimeForFilterHandler (index, showCustomDatepicker) {
      this.selectedValue = this.buttonFiltersArray[index].value
      console.log('showCustomDatepicker', index, showCustomDatepicker)
      for (let i = 0; i < this.buttonFiltersArray.length; i++) {
        if (i !== index) {
          this.buttonFiltersArray[i].selected = false
        } else {
          this.buttonFiltersArray[i].selected = true
        }
      }
      if (this.buttonFiltersArray[index].value !== 'today' && this.buttonFiltersArray[index].value !== 'custom') {
        getDayAccordingToLimits(this.buttonFiltersArray[index].value).then(val => {
          console.log('val123123', val)
          this.filterObject.startDate = val.startDate
          this.filterObject.endDate = val.endDate
          // this.getListing()
        })
      } else {
        let date = new Date(new Date().setHours(0, 0, 0, 0)).toUTCString()
        if (this.buttonFiltersArray[index].value === 'today') {
          this.filterObject.startDate = date
          this.filterObject.endDate = date
          // this.getListing()
        } else {
          this.showCustomDatepicker = showCustomDatepicker
        }
      }
    },
    applyFilter() {
      this.getListing()
    },
    apiCaller () {
      this.isRefresh = false
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading ...'})
      API.ShipworkReqData(
        response => {
          this.requiredDataListing = response.Data === null ? [] : response.Data
          console.log('this.requiredDataListing', this.requiredDataListing)
          this.filterObject.minDate = this.requiredDataListing.minDate
          this.filterObject.maxDate = this.requiredDataListing.maxDate
          this.isRefresh = true
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
        },
        error => {
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    getListing () {
      this.firstLoading = false
      console.log('this.filterObject.startDate 123 123', this.filterObject.startDate)
      console.log('this.filterObject.endDate 123 123', this.filterObject.endDate)
      let utcSTART = moment(this.filterObject.startDate).format("YYYY-MM-DD");
      let utcEND = moment(this.filterObject.endDate).format("YYYY-MM-DD");
      this.$store.dispatch('SetLoader', {status: true, message: 'Please wait, it takes some time ...'})
      this.searchLoader = true
      if (this.filterObject.itemNameList.length === 0) {
        this.filterObject.itemNameList = []
      }
      this.series = []
      this.chartOptions.xaxis.group.groups = []
      this.chartOptions.xaxis.categories = []
      API.overViewReportListingBrandRevenue(
        utcSTART,
        utcEND,
        response => {
          this.searchLoader = false
          this.firstLoading = true
          let listingObjectArr = response.Data === null ? [] : response.Data
          let TempMonth = ['January','February','March','April','May','June','July','August','September','October','November','December']
          for (let index = 0; index < listingObjectArr.length; index++) {
            const element = listingObjectArr[index].monthDetail
            element.sort(function(a, b){
                return TempMonth.indexOf(a.months)
                - TempMonth.indexOf(b.months);
              });
            console.log('listingObjectArr 2', listingObjectArr)
          }
          this.listingObjectArr = listingObjectArr
          if (this.listingObjectArr.length === 1) {
            this.chartOptions.plotOptions.bar.columnWidth = '20%'
          } else {
            this.chartOptions.plotOptions.bar.columnWidth = '70%'
          }
          this.addTitle()
          for (let I = 0; I < this.listingObjectArr.length; I++) {
            for (let JJ = 0; JJ < this.listingObjectArr[I].monthDetail.length; JJ++) {
              let Ele = this.listingObjectArr[I].monthDetail[JJ]
              this.chartOptions.xaxis.categories.push(`${Ele.months} ${this.listingObjectArr[I].year}`)
            }
          }
          for (let I = 0; I < this.listingObjectArr.length; I++) {
            for (let JJ = 0; JJ < this.listingObjectArr[I].monthDetail.length; JJ++) {
              for (let ZZ = 0; ZZ < this.listingObjectArr[I].monthDetail[JJ].AmountDetail.length; ZZ++) {
                let Ele = this.listingObjectArr[I].monthDetail[JJ].AmountDetail[ZZ]
                this.series[0].data.push(Ele.sageRevenue)
                this.series[1].data.push(Ele.edfOrderTotal)
                this.series[2].data.push(Ele.eddOrderTotal)
                this.series[3].data.push(Ele.flexPetZOrderTotal)
                this.series[4].data.push(Ele.perTechOrderTotal)
                this.series[5].data.push(Ele.eBayTDueSeller)
                this.series[6].data.push(Ele.walmartOrderTotal)
              }
            }
          }
          console.log('this.series', this.series)
          // console.log('this.series', this.chartOptions.xaxis.group.groups)
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
        },
        error => {
          this.resetPaginationValues = false
          this.searchLoader = false
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    addTitle () {
      this.series = []
      this.chartOptions.xaxis.group.groups = []
      for (let index = 0; index < this.listingObjectArr.length; index++) {
        this.chartOptions.xaxis.group.groups.push({
          title: this.listingObjectArr[index].year,
          cols: this.listingObjectArr[index].monthDetail.length
        })
      }
       let chartTitle = ['SAGE', 'Extreme Dog Fence', 'Extremee Dog Door', 'FlxPetz', 'Perimeter Technologies', 'eBay', 'Walmart']
       for (let index = 0; index < chartTitle.length; index++) {
         this.series.push({
           name: chartTitle[index],
           data: [],
         })
       }
    },
  },
  destroyed() {
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>

.overFlowParaA {
  word-break: break-all !important;
  white-space: initial !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
}

.loader2 {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1f48c2;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1.2s linear infinite;
}
.centerLine {
  display: flex !important;
  align-items: center !important;
}
/* .graphic-containerA {
  min-width: 600px;
  max-width: 600px;
  overflow-y: auto;
  overflow-x: hidden;
} */
</style>
